<template v-if="listVideos.length > 0">
  <section id="our_partners" class=" mx-2 mx-sm-3">
    <div class="row">
      <div class="col-lg-12">
        <div class="partner_slider_area">
          <!-- v6: pass props directly, do NOT use :options -->
          <Swiper :slides-per-view="4" :space-between="30" :pagination="{ clickable: true }" :watch-overflow="true"
            :breakpoints="{
              0: { slidesPerView: 1, spaceBetween: 10 },   // phones
              768: { slidesPerView: 2, spaceBetween: 20 },   // tablets
              1200: { slidesPerView: 4, spaceBetween: 30 }    // desktops
            }">
            <SwiperSlide v-for="(video, index) in listVideos" :key="index">
              <div class="text-center">
                <div class="video-wrap">
                  <iframe :src="getEmbedUrl(video)" title="YouTube video" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// Swiper v6-compatible imports
import SwiperCore, { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

// v6 CSS bundle (NOT 'swiper/css')
import 'swiper/swiper-bundle.css';

// Register modules in v6
SwiperCore.use([Navigation, Pagination]);

export default {
  name: 'Videos',
  components: { Swiper, SwiperSlide },
  props: {
    listVideos: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  methods: {
    // Extrae el ID de YouTube de múltiples formatos (watch, shorts, embed, youtu.be)
    getYouTubeId(raw) {
      if (!raw) return null;
      const url = typeof raw === 'string' ? raw : (raw.url || '');

      // 1) API URL (más robusto que solo regex)
      try {
        const u = new URL(url);

        // a) youtu.be/<id>
        if (u.hostname.includes('youtu.be')) {
          const id = u.pathname.split('/')[1];
          if (id && id.length === 11) return id;
        }

        // b) youtube.com/watch?v=<id>
        if (u.searchParams.has('v')) {
          const id = u.searchParams.get('v');
          if (id && id.length === 11) return id;
        }

        // c) youtube.com/embed/<id>
        const parts = u.pathname.split('/').filter(Boolean);
        const embedIdx = parts.indexOf('embed');
        if (embedIdx !== -1 && parts[embedIdx + 1]?.length === 11) {
          return parts[embedIdx + 1];
        }

        // d) youtube.com/shorts/<id>
        const shortsIdx = parts.indexOf('shorts');
        if (shortsIdx !== -1 && parts[shortsIdx + 1]?.length === 11) {
          return parts[shortsIdx + 1];
        }
      } catch (_) {
        // Si no es URL válida (string raro), seguimos con regex
      }

      // 2) Fallback por regex
      const m =
        url.match(/(?:youtu\.be\/|\/embed\/|\/shorts\/|[?&]v=)([A-Za-z0-9_-]{11})/) ||
        url.match(/\/v\/([A-Za-z0-9_-]{11})/);

      return m ? m[1] : null;
    },

    // Devuelve la URL de embed segura (nocookie) con params útiles
    getEmbedUrl(input) {
      const id = this.getYouTubeId(input);
      const origin =
        typeof window !== 'undefined' ? encodeURIComponent(window.location.origin) : '';

      if (id) {
        return `https://www.youtube-nocookie.com/embed/${id}?modestbranding=1&rel=0&playsinline=1&enablejsapi=1&origin=${origin}`;
      }

      // Si ya es /embed, la respetamos y añadimos params
      const raw = typeof input === 'string' ? input : (input?.url || '');
      if (raw.includes('/embed/')) {
        const sep = raw.includes('?') ? '&' : '?';
        return `${raw}${sep}modestbranding=1&rel=0&playsinline=1&enablejsapi=1&origin=${origin}`;
      }

      // Último recurso
      return '';
    }
  }
};
</script>

<style scoped>
/* Keep slides auto-height */
:deep(.swiper-wrapper) {
  height: auto !important;
}

/* 16:9 responsive wrapper for iframes */
.video-wrap {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
}

.video-wrap iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
}

:deep(.swiper) {
  width: 100%;
}
</style>
